import { Dispatch, SetStateAction, useState } from "react";
import { option } from "fp-ts";
import { Option } from "fp-ts/Option";

export interface OptionalState<T> {
    value: Option<T>;
    set: (value: T) => void;
    clear: () => void;
    setOptional: Dispatch<SetStateAction<Option<T>>>;
}
export const useOptionalState = <T>(initial?: T): OptionalState<T> => {
    const [value, setValue] = useState<Option<T>>(option.fromNullable(initial));
    // TODO returned functions memoization?
    return {
        value,
        set: (value: T) => setValue(option.some(value)),
        clear: () => setValue(option.none),
        setOptional: setValue,
    };
};
